var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrivacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 29.1V14.5C46.5 6.4 40.1 0 32 0S17.5 6.4 17.5 14.5V29H5.8v35h52.4V29.1zM23.3 14.5c0-4.7 4.1-8.7 8.7-8.7s8.7 4.1 8.7 8.7V29H23.3zm29.1 43.7H11.6V34.9H52.3v23.3z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2NCA2NCIgdmlld0JveD0iMCAwIDY0IDY0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im00Ni41IDI5LjF2LTE0LjZjMC04LjEtNi40LTE0LjUtMTQuNS0xNC41cy0xNC41IDYuNC0xNC41IDE0LjV2MTQuNWgtMTEuN3YzNWg1Mi40di0zNC45em0tMjMuMi0xNC42YzAtNC43IDQuMS04LjcgOC43LTguN3M4LjcgNC4xIDguNyA4Ljd2MTQuNWgtMTcuNHptMjkuMSA0My43aC00MC44di0yMy4zaDUuOCA1LjggMTcuNSA1LjggNS44djIzLjN6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";
export { SvgPrivacy as ReactComponent };